module.exports = __webpack_public_path__ + "build/desktop/img/exclude.66517009f70cc0f0995dbfe50d5cba12.svg";